import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface StickyCTAProps {
  isOrderBumpChecked?: boolean;
}
export function StickyCTA({
  isOrderBumpChecked = false
}: StickyCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const totalPrice = isOrderBumpChecked ? 25490 : 17990;
  const priceText = `$${totalPrice.toLocaleString('es-AR')}`;
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-500 ease-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-162">
      <div className="bg-forest/95 backdrop-blur-md border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] px-4 py-3" data-id="element-163">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-3" data-id="element-164">
          {/* Price info */}
          <div className="hidden sm:block text-white shrink-0" data-id="element-165">
            <p className="text-xs text-white/70 leading-tight" data-id="element-166">
              <span className="line-through" data-id="element-167">$89.000</span> → Precio lanzamiento
            </p>
            <p className="text-xl font-bold leading-tight transition-all duration-300" data-id="element-168">
              {priceText}{' '}
              <span className="text-xs font-normal text-white/60" data-id="element-169">ARS</span>
            </p>
            {isOrderBumpChecked && <p className="text-[10px] text-amber-300 leading-tight mt-0.5" data-id="element-170">
                ✨ Incluye Kit del Sueño Profundo
              </p>}
          </div>

          {/* CTA Button */}
          <a href={isOrderBumpChecked ? 'https://www.ebookpromax.com/cart/46629774295198:1' : 'https://www.ebookpromax.com/cart/46629742641310:1'} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart(isOrderBumpChecked ? 25490 : 17990, 'ARS', isOrderBumpChecked ? 'Botiquín Ancestral + Kit del Sueño' : 'Botiquín Ancestral')} className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-white text-forest font-bold text-base sm:text-lg px-6 py-3 rounded-xl hover:bg-cream transition-colors shadow-lg active:scale-[0.98]" data-id="element-171">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-172" />
            <span className="sm:hidden" data-id="element-173">COMPRAR AHORA — {priceText}</span>
            <span className="hidden sm:inline" data-id="element-174">
              🛒 QUIERO MI BOTIQUÍN AHORA
            </span>
          </a>
        </div>
      </div>
    </div>;
}